import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ContactUs from "./ContactUs";


class HelpModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHelpModal: false,
            showContactUs: false
        };
    }
    componentDidMount() {
        this.setState({ showHelpModal: false });
    }

    handleHelpClose = () => {
        this.setState({ showHelpModal: false });
    }
    handleHelpShow = () => {
        this.setState({ showHelpModal: true });
    }
    handleShowContactUs = () => {
        this.setState({
            showHelpModal: false,
            showContactUs: true,
        });
    }
    handleCloseContactUs = () => {
        this.setState({
            showContactUs: false,
        });
    }

    render() {
        return (
            <>
                <Modal
                    title="Contact Us"
                    centered
                    show={this.state.showContactUs}
                    onHide={this.handleCloseContactUs}
                    dialogClassName="custom-modal-width"
                >
                    <Modal.Header closeButton>
                        Contact us
                    </Modal.Header>
                    <Modal.Body className="help-contact-us">
                        <ContactUs />
                    </Modal.Body>
                </Modal>
                <Modal title="Help" show={this.state.showHelpModal} onHide={this.handleHelpClose} dialogClassName="custom-modal-width" centered>
                    <Modal.Header closeButton>Help</Modal.Header>
                    <Modal.Body className="text-align-justify">
                        <p><strong>Do you need help with something technical?</strong>
                        </p>
                        <p>If you are encountering any technical issues please call <span className="custom-ocean-color">0208 057 1200</span>.</p>
                        <p>This service is available Monday to Friday 9am - 5pm.</p>
                        <p>Outside of those hours please email: <span className="custom-ocean-color">optsupport@bdo.co.uk</span></p>
                        <br />
                        <p><strong>Do you need help with a tax related matter?</strong></p>
                        <p>Get in touch with you tax representative via the button below</p>
                        <button onClick={this.handleShowContactUs} className="button">Message</button>
                    </Modal.Body>
                </Modal>
                <button type="button" className="custom-white-btn" onClick={this.handleHelpShow}>Help<span className="icon-circle-exclamation">!</span></button>
            </>
        );
    }
}

export default HelpModal;